export const addS3Url = (url) => {
  return `${process.env.REACT_APP_S3_URL}${url}`;
};
